<template>
<div>
	
<div v-if="embeddata.youtube && embeddata.youtube.length > 0" class="row">
	<div :class="classW" v-for="YT in embeddata.youtube" :key="YT">
		<a v-if="show_link == 1" :href="embeddata.link" target="_blank" class="gold">
			<b v-text="embeddata.title"></b>
		</a>
		<b-embed
			type="iframe"
			aspect="16by9"
			:src="'https://www.youtube.com/embed/' + YT + '?rel=0'"
			allowfullscreen
		></b-embed>
	</div>
</div>


<div v-if="embeddata.vimeo && embeddata.vimeo.length > 0">
	<div class="row mt-2">
		<div :class="classW" v-for="V in embeddata.vimeo" :key="V">
			<a v-if="show_link == 1" :href="embeddata.link" target="_blank" class="gold">
				<b v-text="embeddata.title"></b>
			</a><br />
			<iframe 
				:src="'https://player.vimeo.com/video/' + V" 
				class="playerD"
				frameborder="0" 
				allow="autoplay; fullscreen" allowfullscreen>
			</iframe>
		</div>
	</div>
</div>


</div>
</template>

<script>
export default {
name: 'VideoEmbeds',
	props: {
		embeddata: Object,
		classW: String,
	},
	data() {
		return {
			show_link: 0,
		}
	},
	computed: {
	},
	methods: {
	}
}  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.playerD {
	width: 100%;
	height: 200px;
	text-align: left;
}
@media only screen and (max-width: 600px) {
	.playerD {
		width: 100%;
		height: 175px;
	}
}
</style>
